import React, { useCallback } from 'react';
import { BaseTour } from './BaseTour';
import { useWizardQuery, useCompleteWizardMutation } from '../../../hooks/useWizardsQuery';

const TOUR_STEPS = [
    {
        target: 'body',
        title: '📝 Welcome to Forms!',
        content: 'This is your Forms hub. Here you can see all forms assigned to you, check submission stats, and manage your sync queue.',
        placement: 'center',
        disableBeacon: true,
        blockTargetInteraction: true,
    },
    {
        target: '#tour-forms-submitted-card',
        title: '✅ Submitted Forms',
        content: 'See how many of your forms have submissions. Tap "View All" to browse all submitted forms.',
        placement: 'bottom-start',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-forms-all-card',
        title: '📄 All Forms',
        content: 'This shows the total number of forms assigned to you. Tap "View All" to see the complete list.',
        placement: 'bottom-end',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-forms-sync-card',
        title: '🔄 Sync Status',
        content: 'Any pending (unsynced) submissions appear here. Tap "Sync Now" to push your data to the server when you\'re online.',
        placement: 'bottom',
        blockTargetInteraction: true,
    },
    {
        target: '#tour-forms-list',
        title: '📋 Your Form List',
        content: 'Here are your most recent forms. Tap "Start Now" on any active form to begin collecting data. Draft forms cannot be filled until published by your admin.',
        placement: 'top',
        blockTargetInteraction: true,
    },
    {
        target: 'body',
        title: '🚀 Ready to Collect Data!',
        content: 'Pick a form and start filling it out. Your submissions will be saved locally and synced when you\'re online.',
        placement: 'center',
        blockTargetInteraction: true,
    },
];

export const FormsTour = () => {
    const wizardKey = 'sina_pwa_forms_tour_completed';
    const { data: wizardData, isLoading } = useWizardQuery(wizardKey);
    const completeMutation = useCompleteWizardMutation(wizardKey);

    const isCompleted = !!wizardData?.completed;

    const handleTourComplete = useCallback(() => {
        completeMutation.mutate(undefined, {
            onError: (error) => {
                console.warn('Failed to mark forms tour as completed via API', error);
            },
        });
    }, [completeMutation]);

    // Don't render while loading to avoid flash
    if (isLoading) return null;

    return (
        <BaseTour 
            steps={TOUR_STEPS} 
            storageKey={wizardKey}
            isCompleted={isCompleted}
            onTourComplete={handleTourComplete}
            skipPrompt={true}
        />
    );
};
